import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {UtilsService} from "../../utils/utils.service";
import {PrintOptionInventaire} from "../../models/gestion-stock/print-inventaire.model";
import {PrintOption} from "../../../gestion-stocks/stocks/inventaire/dialog-print-inventaire/dialog-print-inventaire.component";

@Injectable()
export class PrintInventaireService {

  constructor(
              private utils: UtilsService,
              private httpClient: HttpClient){

  }

  extractInventaire(printOptionInventaire: PrintOptionInventaire, printMode: boolean) {
    let url = printMode ? 'dolrest/gestion-stocks/print/inventaire?1=1' : 'dolrest/gestion-stocks/export/inventaire?1=1';
    if (printOptionInventaire) {
      if (printOptionInventaire.printOptions) {
        if (printOptionInventaire.printOptions.find(opt => opt === PrintOption.hideEmpty))
          url += `&hideEmpty=${(printOptionInventaire.printOptions.some(opt => opt === PrintOption.hideEmpty)) ? 'true' : 'false'}`;
        if (printOptionInventaire.printOptions.find(opt => opt === PrintOption.detailsAccounting))
          url += `&detailsAccounting=${(printOptionInventaire.printOptions.some(opt => opt === PrintOption.detailsAccounting)) ? 'true' : 'false'}`;
        if (printOptionInventaire.printOptions.find(opt => opt === PrintOption.detailsByLot))
          url += `&detailsByLot=${(printOptionInventaire.printOptions.some(opt => opt === PrintOption.detailsByLot)) ? 'true' : 'false'}`;
        if (printOptionInventaire.printOptions.find(opt => opt === PrintOption.showQuantite))
          url += `&showQuantite=${(printOptionInventaire.printOptions.some(opt => opt === PrintOption.showQuantite)) ? 'true' : 'false'}`;
      }

      if (printOptionInventaire.searchSupplierWrapper && printOptionInventaire.searchSupplierWrapper.filtersMap) {
        let args = '';
        const searchStockSupplier: any = printOptionInventaire.searchSupplierWrapper.filtersMap;
        if (searchStockSupplier) {
          if(searchStockSupplier.dateEntree) args += `&dateEntree=${this.utils.convertYYYYMMdd(Date.parse(searchStockSupplier.dateEntree))}`;
          if(searchStockSupplier.datePeremption) args += `&datePeremption=${this.utils.convertYYYYMMdd(Date.parse(searchStockSupplier.datePeremption))}`;
          if(searchStockSupplier.denominationArticle) args += `&denominationArticle=${searchStockSupplier.denominationArticle}`;
          if(searchStockSupplier.referenceInterneArticle) args += `&referenceInterneArticle?=${searchStockSupplier.referenceInterneArticle}`;
          if(searchStockSupplier.seuil) args += `&seuil=${searchStockSupplier.seuil}`;
          if(searchStockSupplier.denree) args += `&denree=${searchStockSupplier.denree}`;
          if(searchStockSupplier.codeDenree) args += `&codeDenree=${searchStockSupplier.codeDenree}`;

          if (searchStockSupplier.sitesIds && searchStockSupplier.sitesIds.length) args += `&sitesIds=${searchStockSupplier.sitesIds}`;
          if (searchStockSupplier.idsUniteProductionZonesStockage && searchStockSupplier.idsUniteProductionZonesStockage.length) args += `&idsUniteProductionZonesStockage=${searchStockSupplier.idsUniteProductionZonesStockage}`;
          if (searchStockSupplier.idsZonesStockage && searchStockSupplier.idsZonesStockage.length) args += `&idsZonesStockagesSelected=${searchStockSupplier.idsZonesStockage}`;
        }
        url += args;
      }
    }

    const headers = printMode ? new HttpHeaders().set('Accept', 'application/pdf') : new HttpHeaders().set('Accept', 'application/vnd.ms-excel');

    return this.httpClient.get(url,{
      headers: headers,
      responseType: 'blob'
    }).pipe(
      catchError(err => this.utils.handleError(err, true))
    );
  }

}
